import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import ShareButtons from 'hb-react/frontoffice/components/ShareButtons';

const Success = ({
  successPageContent,
  headline,
  tagline,
  sharingParameters = {},
}) => (
  <>
    {successPageContent ? (
      <Box
        display="block"
        className="ckeditor-content--reset"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: successPageContent }}
      />
    ) : (
      <>
        <Headline headline={headline} />
        <Tagline tagline={tagline} />
      </>
    )}
    {!isEmpty(sharingParameters) && (
      <div className="text--center push-double--top">
        <ShareButtons
          url={sharingParameters.url}
          title={sharingParameters.title}
          className="icon-size--150"
        />
      </div>
    )}
  </>
);

Success.propTypes = {
  successPageContent: PropTypes.string,
  headline: PropTypes.string,
  tagline: PropTypes.string,
  sharingParameters: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
};

const Headline = ({ headline }) => (
  <Box as="h1" mb={3} textAlign="center" font="h1-semibold">
    {headline || s__('donations|Thank you for your support!')}
  </Box>
);

const Tagline = ({ tagline }) => {
  if (!tagline) {
    return null;
  }

  return (
    <Box as="h2" mb={3} textAlign="center" font="h3-semibold">
      {tagline}
    </Box>
  );
};

export default Success;
